import { render, staticRenderFns } from "./BottomImage.vue?vue&type=template&id=4da28908&"
import script from "./BottomImage.vue?vue&type=script&lang=js&"
export * from "./BottomImage.vue?vue&type=script&lang=js&"
import style0 from "./BottomImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports